import React, { createContext, useContext, useState } from "react";

const NewScanWizardContext = createContext();

export function NewScanWizardProvider({ children }) {
  const [selectedToolIds, setSelectedToolIds] = useState([]);
  const [targets, setTargets] = useState([]);
  const [authorizationConfirmed, setAuthorizationConfirmed] = useState(false);
  const [config, setConfig] = useState({});

  const value = {
    selectedToolIds,
    setSelectedToolIds,
    targets,
    setTargets,
    authorizationConfirmed,
    setAuthorizationConfirmed,
    config,
    setConfig,
  };

  return (
    <NewScanWizardContext.Provider value={value}>
      {children}
    </NewScanWizardContext.Provider>
  );
}

export function useNewScanWizard() {
  const context = useContext(NewScanWizardContext);
  if (!context) {
    throw new Error("useNewScanWizard must be used within NewScanWizardProvider");
  }
  return context;
}
